import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import HomeView from '../views/HomeView.vue'
import SectionView from '../views/SectionView.vue'
import UnityView from '../views/UnityView.vue'
import LevelView from '../views/LevelView.vue'
import CreateLevelView from '../views/CreateLevelView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import UserSectionView from '../views/SeeUsers/SeeUsersFirstView.vue'
import UserSectionSecondView from '../views/SeeUsers/SeeUsersSecondView.vue'
import UserSectionThirdView from '../views/SeeUsers/SeeUsersThirdView.vue'
import TermsView from '@/views/TermsView.vue'
import DeleteView from '@/views/DeleteView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/section/:id',
    name: 'section',
    component: SectionView,
  },
  {
    path: '/unities/:areaId/:sectionId',
    name: 'unity',
    component: UnityView,
  },
  {
    path: '/unity/levels/:areaId/:id',
    name: 'level',
    component: LevelView,
  },
  {
    path: '/level/:id',
    name: 'create-level',
    component: CreateLevelView,
  },
  {
    path: '/see-users/:id',
    name: 'see-users',
    component: UserSectionView,
  },
  {
    path: '/see-specific-user/:sectionId/:userId',
    name: 'see-specific',
    component: UserSectionSecondView,
  },
  {
    path: '/see-specific-user-area/:sectionId/:userId/:areaId',
    name: 'see-specific-area',
    component: UserSectionThirdView,
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsView,
  },
  {
    path: '/delete',
    name: 'delete',
    component: DeleteView,
  },
  {
    path: '*',
    name: 'not-found',
    component: NotFoundView,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const publicRoutes = ['login', 'register', 'forgot'];
  const isPublicRoute = publicRoutes.includes(to.name);

  // Verificar la autenticación del usuario
  const isAuthenticated = localStorage.getItem("token") == null;

  if (isAuthenticated && !isPublicRoute && !"not-found".includes(to.name) && !"terms".includes(to.name) && !"delete".includes(to.name)) {
    next({ name: 'login' });
  } else if (isAuthenticated == false && isPublicRoute) {
    next({ name: 'home' })
  } else {
    next();
  }
});

export default router
